import { Link } from 'react-router-dom';
import '../styles/About.css'; // About ki CSS

function About() {
  return (
    <div className="about-page-wrapper">
      {/* Animated Background Glows */}
      <div className="about-bg-glow about-bg-glow-1"></div>
      <div className="about-bg-glow about-bg-glow-2"></div>
      <div className="about-bg-glow about-bg-glow-3"></div>

      <div className="about-container">
        {/* ============================= */}
        {/* HERO SECTION */}
        {/* ============================= */}
        <section className="about-hero-section">
          <div className="about-hero-content">
            <span className="about-hero-badge">🏆 About Us</span>
            <h1 className="about-hero-title">
              Empowering <span className="about-hero-highlight">Athletes</span> and <br />
              <span className="about-hero-highlight">Teams</span> Across India
            </h1>
            <p className="about-hero-description">
              VernaEvents is India's fastest growing sports event management platform, 
              connecting athletes, teams, and organizers through seamless event discovery 
              and registration.
            </p>
            <div className="about-hero-stats">
              <div className="about-hero-stat">
                <span className="about-hero-stat-number">50+</span>
                <span className="about-hero-stat-label">Events Hosted</span>
              </div>
              <div className="about-hero-stat">
                <span className="about-hero-stat-number">200+</span>
                <span className="about-hero-stat-label">Teams Registered</span>
              </div>
              <div className="about-hero-stat">
                <span className="about-hero-stat-number">10+</span>
                <span className="about-hero-stat-label">Sports Categories</span>
              </div>
              <div className="about-hero-stat">
                <span className="about-hero-stat-number">98%</span>
                <span className="about-hero-stat-label">Satisfaction Rate</span>
              </div>
            </div>
            <div className="about-hero-buttons">
              <Link to="/events" className="about-hero-btn-primary">
                Explore Events →
              </Link>
              <Link to="/contact" className="about-hero-btn-secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* OUR STORY SECTION */}
        {/* ============================= */}
        <section className="about-story-section">
          <div className="about-story-content">
            <div className="about-story-left">
              <span className="about-section-badge">📖 Our Story</span>
              <h2 className="about-section-title">
                Born from a <span className="about-highlight-text">Simple Idea</span>
              </h2>
              <p className="about-story-text">
                VernaEvents was founded in 2024 with a singular vision: to democratize 
                sports event access for everyone. What started as a small community 
                initiative has now grown into India's trusted sports event platform.
              </p>
              <p className="about-story-text">
                We believe that <strong>every athlete deserves a stage</strong> to showcase 
                their talent. Whether you're a professional team chasing glory or a group 
                of friends playing for fun, VernaEvents is your gateway to the world of 
                competitive sports.
              </p>
              <div className="about-story-timeline">
                <div className="about-timeline-item">
                  <span className="about-timeline-year">2024</span>
                  <span className="about-timeline-text">Founded with a vision</span>
                </div>
                <div className="about-timeline-item">
                  <span className="about-timeline-year">2025</span>
                  <span className="about-timeline-text">50+ events hosted</span>
                </div>
                <div className="about-timeline-item">
                  <span className="about-timeline-year">2026</span>
                  <span className="about-timeline-text">200+ teams & growing</span>
                </div>
              </div>
            </div>
            <div className="about-story-right">
              <div className="about-story-image-placeholder">
                <span>🏆</span>
              </div>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* MISSION & VISION SECTION */}
        {/* ============================= */}
        <section className="about-mission-section">
          <div className="about-mission-grid">
            <div className="about-mission-card">
              <span className="about-mission-icon">🎯</span>
              <h3>Our Mission</h3>
              <p>
                To empower every athlete by providing a seamless, accessible platform 
                for discovering, registering, and excelling in sports events across India.
              </p>
              <ul className="about-mission-list">
                <li>✓ Democratize sports event access</li>
                <li>✓ Empower athletes of all levels</li>
                <li>✓ Build a thriving sports community</li>
              </ul>
            </div>
            <div className="about-mission-card">
              <span className="about-mission-icon">🌟</span>
              <h3>Our Vision</h3>
              <p>
                To build India's largest sports ecosystem where talent meets opportunity, 
                fostering a vibrant community of athletes and sports enthusiasts.
              </p>
              <ul className="about-mission-list">
                <li>✓ India's leading sports platform</li>
                <li>✓ Connect talent with opportunity</li>
                <li>✓ Foster sports excellence</li>
              </ul>
            </div>
            <div className="about-mission-card">
              <span className="about-mission-icon">💪</span>
              <h3>Our Values</h3>
              <p>
                Integrity, innovation, and inclusivity are at the heart of everything we do. 
                We believe in creating a fair and transparent environment for all.
              </p>
              <ul className="about-mission-list">
                <li>✓ Integrity & Transparency</li>
                <li>✓ Innovation & Excellence</li>
                <li>✓ Inclusivity & Fairness</li>
              </ul>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* WHAT WE OFFER SECTION */}
        {/* ============================= */}
        <section className="about-offer-section">
          <div className="about-offer-header">
            <span className="about-section-badge">⚡ What We Offer</span>
            <h2 className="about-section-title">
              Everything You Need to <span className="about-highlight-text">Compete</span>
            </h2>
            <p className="about-offer-subtitle">
              From discovering events to registering your team — we've got you covered
            </p>
          </div>
          <div className="about-offer-grid">
            <div className="about-offer-card">
              <div className="about-offer-icon-wrapper">
                <span className="about-offer-icon">🔍</span>
              </div>
              <h3>Event Discovery</h3>
              <p>Find and explore sports events happening near you with our smart search and filter system</p>
              <ul>
                <li>✓ Search by sport, location, date</li>
                <li>✓ Filter by category & status</li>
                <li>✓ Real-time availability updates</li>
              </ul>
            </div>
            <div className="about-offer-card">
              <div className="about-offer-icon-wrapper">
                <span className="about-offer-icon">📝</span>
              </div>
              <h3>Easy Registration</h3>
              <p>Register your team in just a few simple steps with our streamlined registration process</p>
              <ul>
                <li>✓ Quick team registration</li>
                <li>✓ Player management</li>
                <li>✓ Instant confirmation</li>
              </ul>
            </div>
            <div className="about-offer-card">
              <div className="about-offer-icon-wrapper">
                <span className="about-offer-icon">👥</span>
              </div>
              <h3>Team Management</h3>
              <p>Manage your team members, bookings, and schedules effortlessly from one dashboard</p>
              <ul>
                <li>✓ Team member management</li>
                <li>✓ Booking history</li>
                <li>✓ Schedule tracking</li>
              </ul>
            </div>
            <div className="about-offer-card">
              <div className="about-offer-icon-wrapper">
                <span className="about-offer-icon">🏅</span>
              </div>
              <h3>Competitive Events</h3>
              <p>Participate in tournaments with exciting prizes and recognition for your achievements</p>
              <ul>
                <li>✓ Professional tournaments</li>
                <li>✓ Cash prizes & trophies</li>
                <li>✓ Recognition & rankings</li>
              </ul>
            </div>
            <div className="about-offer-card">
              <div className="about-offer-icon-wrapper">
                <span className="about-offer-icon">📱</span>
              </div>
              <h3>Mobile Friendly</h3>
              <p>Access all features on any device, anytime, anywhere with our responsive design</p>
              <ul>
                <li>✓ Responsive design</li>
                <li>✓ Mobile optimized</li>
                <li>✓ Access anywhere</li>
              </ul>
            </div>
            <div className="about-offer-card">
              <div className="about-offer-icon-wrapper">
                <span className="about-offer-icon">🔒</span>
              </div>
              <h3>Secure & Trusted</h3>
              <p>Your data is safe with us. Transparent and fair registration process for all events</p>
              <ul>
                <li>✓ Secure payments</li>
                <li>✓ Transparent process</li>
                <li>✓ Data protection</li>
              </ul>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* WHY CHOOSE US SECTION */}
        {/* ============================= */}
        <section className="about-why-section">
          <div className="about-why-header">
            <span className="about-section-badge">⭐ Why Choose Us</span>
            <h2 className="about-section-title">
              Why Athletes & Teams <span className="about-highlight-text">Trust Us</span>
            </h2>
          </div>
          <div className="about-why-grid">
            <div className="about-why-card">
              <div className="about-why-number">01</div>
              <h3>Proven Track Record</h3>
              <p>With 50+ successful events and 200+ registered teams, we've built a reputation for excellence in sports event management.</p>
            </div>
            <div className="about-why-card">
              <div className="about-why-number">02</div>
              <h3>Diverse Sports Categories</h3>
              <p>From cricket and football to basketball and badminton — we cover 10+ sports categories for athletes of all interests.</p>
            </div>
            <div className="about-why-card">
              <div className="about-why-number">03</div>
              <h3>Seamless Experience</h3>
              <p>Our platform is designed to provide a smooth and intuitive experience from event discovery to team registration.</p>
            </div>
            <div className="about-why-card">
              <div className="about-why-number">04</div>
              <h3>Trusted by Thousands</h3>
              <p>With a 98% satisfaction rate, athletes and teams trust VernaEvents for their competitive sports journey.</p>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* TESTIMONIALS SECTION */}
        {/* ============================= */}
        <section className="about-testimonials-section">
          <div className="about-testimonials-header">
            <span className="about-section-badge">💬 Testimonials</span>
            <h2 className="about-section-title">
              What Our <span className="about-highlight-text">Community Says</span>
            </h2>
          </div>
          <div className="about-testimonials-grid">
            <div className="about-testimonial-card">
              <div className="about-testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="about-testimonial-text">
                "VernaEvents made it incredibly easy for our college team to find and register for tournaments. The process was smooth and hassle-free!"
              </p>
              <div className="about-testimonial-author">
                <span className="about-testimonial-name">Rahul Sharma</span>
                <span className="about-testimonial-role">Captain, Thunder Strikers</span>
              </div>
            </div>
            <div className="about-testimonial-card">
              <div className="about-testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="about-testimonial-text">
                "As an event organizer, VernaEvents has been a game-changer. The platform helped us reach more teams and manage registrations efficiently."
              </p>
              <div className="about-testimonial-author">
                <span className="about-testimonial-name">Priya Patel</span>
                <span className="about-testimonial-role">Event Organizer</span>
              </div>
            </div>
            <div className="about-testimonial-card">
              <div className="about-testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p className="about-testimonial-text">
                "Finding the right tournaments for our team used to be a challenge. VernaEvents changed everything. Now we never miss an opportunity!"
              </p>
              <div className="about-testimonial-author">
                <span className="about-testimonial-name">Amit Kumar</span>
                <span className="about-testimonial-role">Coach, City FC</span>
              </div>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* FAQ SECTION */}
        {/* ============================= */}
        <section className="about-faq-section">
          <div className="about-faq-header">
            <span className="about-section-badge">❓ FAQ</span>
            <h2 className="about-section-title">
              Frequently Asked <span className="about-highlight-text">Questions</span>
            </h2>
          </div>
          <div className="about-faq-grid">
            <div className="about-faq-item">
              <h4>What is VernaEvents?</h4>
              <p>VernaEvents is India's premier sports event discovery and registration platform connecting athletes, teams, and organizers.</p>
            </div>
            <div className="about-faq-item">
              <h4>How do I register my team?</h4>
              <p>Browse events, click "Register Now", fill in your team details, and submit. You'll receive a confirmation email instantly.</p>
            </div>
            <div className="about-faq-item">
              <h4>What sports are available?</h4>
              <p>We offer 10+ sports including Cricket, Football, Basketball, Volleyball, Tennis, and Badminton.</p>
            </div>
            <div className="about-faq-item">
              <h4>Is there a registration fee?</h4>
              <p>Registration fees vary by event. Each event listing clearly displays the applicable fee.</p>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* CTA SECTION */}
        {/* ============================= */}
        <section className="about-cta-section">
          <div className="about-cta-content">
            <span className="about-cta-icon">🚀</span>
            <h2 className="about-cta-title">
              Ready to <span className="about-cta-highlight">Get Started</span>?
            </h2>
            <p className="about-cta-description">
              Join thousands of athletes and teams already competing on VernaEvents. 
              Discover your next tournament and start your journey to victory today!
            </p>
            <div className="about-cta-buttons">
              <Link to="/events" className="about-cta-btn-primary">
                Explore Events →
              </Link>
              <Link to="/contact" className="about-cta-btn-secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* FOOTER NOTE */}
        {/* ============================= */}
        <div className="about-footer-note">
          <p>© 2026 VernaEvents. All rights reserved. | Made with ❤️ for sports enthusiasts</p>
        </div>
      </div>
    </div>
  );
}

export default About;